/**
 * ntc-compatibilita.js — dice se il pezzo si monta sull'auto scelta dal cliente.
 *
 * ⚠️ L'auto sta nel BROWSER del cliente (`ntc_auto` in localStorage), scritta dalla barra
 * in cima. Qui si LEGGE soltanto: nessun dato esce dalla pagina.
 *
 * ⛔ IL CONFRONTO SI FA AL LIVELLO PIU' PRECISO CHE IL CLIENTE HA SCELTO. Confrontare
 * sempre e solo la marca direbbe «ci monta» a chiunque abbia una BMW, anche se il pezzo e'
 * solo per la Serie 5 E60. E chi ha scelto la versione va confrontato con la versione, non
 * col modello: la riga «Serie 5 E61» non deve dire di si' a una E60.
 *
 * ⚠️ Quando non risulta, si scrive «non risulta compatibile», non «non compatibile»: il
 * catalogo non e' completo, e mandare via un cliente per una riga mancante e' peggio che
 * invitarlo a chiedere.
 */
( function () {
  'use strict';

  function auto() {
    try {
      var s = window.localStorage.getItem( 'ntc_auto' );
      return s ? JSON.parse( s ) : null;
    } catch ( e ) { return null; }
  }

  function su( s ) { return String( s || '' ).toUpperCase().trim(); }

  /** Il pezzo si monta sul veicolo scelto? */
  function combacia( righe, tag ) {
    var scelto = su( tag );
    if ( ! scelto ) { return null; }

    for ( var i = 0; i < righe.length; i++ ) {
      var r = righe[ i ];
      var ma = su( r.ma ), mo = su( r.mo ), ve = su( r.ve );
      if ( ! ma || scelto.indexOf( ma ) !== 0 ) { continue; }

      var resto = scelto.slice( ma.length ).trim();
      if ( ! resto ) { return r; }                     // ha scelto solo la marca

      if ( ! mo ) { continue; }
      if ( resto.indexOf( mo ) !== 0 ) { continue; }

      var codice = resto.slice( mo.length ).trim();
      if ( ! codice ) { return r; }                    // ha scelto marca + modello

      // ⚠️ Il telaio nel catalogo e' scritto per esteso — «VII (5G1, BE1, BE2, MK7)» —
      // mentre il tag porta un codice solo: si cerca il codice DENTRO alla stringa lunga.
      if ( ! ve ) { return r; }                        // la riga vale per tutto il modello
      if ( ve.indexOf( codice ) !== -1 ) { return r; }
    }
    return false;
  }

  function avvia( radice ) {
    var righe;
    try {
      righe = JSON.parse( radice.getAttribute( 'data-veicoli' ) || '[]' );
    } catch ( e ) { return; }
    if ( ! righe.length ) { return; }

    var verdetto = radice.querySelector( '[data-ntc="verdetto"]' );
    var invito = radice.querySelector( '[data-ntc="invito"]' );
    var v = auto();
    if ( ! v || ! v.tag ) { return; }                  // resta l'invito a scegliere l'auto

    var esito = combacia( righe, v.tag );
    var nome = v.nome || v.tag;
    // ⚠️ Le due frasi arrivano dall'editor, non dal codice: `{auto}` e' il segnaposto dove
    //    va il nome del veicolo scelto. Cosi' si riscrivono senza toccare un file.
    var frase = radice.getAttribute( esito ? 'data-testo-si' : 'data-testo-no' ) || '';
    verdetto.className = 'ntc-comp__verdetto ntc-comp__verdetto--' + ( esito ? 'si' : 'no' );
    verdetto.textContent = ( esito ? '✓ ' : '⚠ ' ) + frase.replace( '{auto}', nome );
    verdetto.hidden = false;
    if ( invito ) { invito.hidden = true; }
  }

  function tutte() {
    document.querySelectorAll( '[data-ntc-compatibilita]' ).forEach( avvia );
  }
  if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', tutte );
  } else { tutte(); }
  document.addEventListener( 'shopify:section:load', tutte );
}() );
